import { connect } from 'react-redux';
import { compose, withProps, flattenProp } from 'recompose';
import {
  withFirebase,
  withFirestore,
  isEmpty,
  isLoaded
} from 'react-redux-firebase';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { saveProfile } from '../../../store/actions/companyActions';

const styles = theme => ({
  appBar: {
    position: 'relative'
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
      width: 1000,
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  paper: {
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 3,
    padding: theme.spacing.unit * 2,
    [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
      marginTop: theme.spacing.unit * 6,
      marginBottom: theme.spacing.unit * 6,
      padding: theme.spacing.unit * 3
    }
  },
  stepper: {
    padding: `${theme.spacing.unit * 3}px 0 ${theme.spacing.unit * 5}px`,
    marginBottom: '20px',
    marginTop: '20px'
  },
  buttons: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '40px'
  },
  nextButton: {
    marginTop: theme.spacing.unit * 3,
    color: '#ffffff',
    paddingLeft: 50,
    paddingRight: 50
  },
  backButton: {
    marginTop: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit,
    color: '#000000',
    paddingLeft: 50,
    paddingRight: 50
  },
  headerStyle: {
    color: '#6441a4'
  }
});

const mapStateToProps = state => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile
  };
};

const mapDispatchToProps = dispatch => {
  return {
    saveProfile: companyInfo => dispatch(saveProfile(companyInfo))
  };
};

export default compose(
  // Map redux state to props
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  // Add props.router (used in handlers)
  withRouter,

  // Add props.firebase (used in handlers)
  withFirebase,

  withFirestore,

  // Add custom props
  withProps(({ auth, profile }) => ({
    auth,
    profile
  })),
  // Flatten profile so that avatarUrl and displayName are props
  flattenProp('profile'),
  // Add styles as classes prop
  withStyles(styles)
);



// WEBPACK FOOTER //
// ./src/components/sign-up/company/CompanySignUp.enhancer.js